import styled from 'styled-components';
import {
  MARGIN,
  BREAKPOINT,
  PADDING,
  REBRAND_COLOR,
  REBRAND_GRADIENT
} from '@latitude/core/utils/constants';
import Section from '@latitude/section-rebrand';

export const StyledHeroContainer = styled.div`
  background: ${REBRAND_COLOR.INDIGO};
  min-height: calc(100vh - 56px);
  display: flex;
  flex-direction: column;

  @media (min-width: ${BREAKPOINT.LG}) {
    min-height: calc(100vh - 80px);
  }
`;

export const StyledImageContainer = styled.div`
  flex: 8;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  border-radius: 0 0 0 50px;

  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;

  h2 {
    u {
      text-decoration: none;
      background-image: ${REBRAND_GRADIENT.WHITE_TEXT_UNDERLINE};
      background-repeat: no-repeat;
      background-position: left 20px bottom 5px;
      background-size: calc(100% - 5px) 5px;
    }
  }
`;

export const StyledTextWrapper = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & * {
    text-align: center;
  }

  a:hover,
  a:focus-visible {
    border-bottom: none !important;
  }
  background: ${REBRAND_GRADIENT.SKYWARD_BLUE};
`;

export const StyledTextContainer = styled(Section)`

`;

export const StyledButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: ${MARGIN.M32};
  @media (min-width: ${BREAKPOINT.MD}) {
    flex-direction: row;
  }
  a {
    text-decoration: none;
    cursor: pointer;
    border-bottom: none;
  }
`;

export const StyledButtonSeparator = styled.div`
  width: 113px;
  height: 1.6px;
  background-color: ${REBRAND_COLOR.WHITE};
  margin: ${MARGIN.M24} 0;
  @media (min-width: ${BREAKPOINT.MD}) {
    margin: 0 ${MARGIN.M32};
    width: 1.6px;
    height: 122px;
  }
`;
